<template>
 <div>
  <div id="app">
    <navbarmenu></navbarmenu>
    <div style="flex:1;" class="espac">
      <router-view />
    </div>
    <barrainferior></barrainferior>
  </div>
 </div>
</template>

<script>
import NavbarMenu from "./components/NavbarMenu.vue";
import { routes } from "./routes";
import BarraInferior from "./components/BarraInferior.vue";
export default {
  name: 'App',
  components: {
    navbarmenu:NavbarMenu,
    barrainferior:BarraInferior
  },
  data() {
    return {
      routes
    };
  }
  
};

</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
.h2 {
  font-family: Georgia, 'Times New Roman', Times, serif;
  text-align: center;
  padding-top: 2vh;
}
.h3 {
  font-family: Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  text-align: justify;
  padding-top: 2vh;
}
.bronze{
    color: rgb(114, 92, 29) ;
}
.linkbold{
    color: black;
    text-decoration: underline;
}

.espac{
    padding-left: 2%;
    padding-right: 1%;
}

.maiuscula {
  text-transform: uppercase;
  
}

</style>
